<script setup>
import KdContainer from "./kdContainer.vue";
import KdTempSolutionForm from "@/components/kdAuditForm/kdTempSolutionForm.vue";
</script>

<template>
  <kd-container>
    <el-form :model="form" :rules="rules" ref="formRef" label-width="128px">
      <el-form-item label="根因分析" prop="reasonAnalyst">
        <el-input
          :disabled="receivedForm && receivedForm.reasonAnalyst !== ''"
          placeholder="请输入根因分析"
          v-model="form.reasonAnalyst"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 4 }"
          maxlength="500"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item>
        <file-upload-list
          ref="fileUploadList"
          :fileList="form.file"
        ></file-upload-list>
      </el-form-item>

      <el-form-item label="临时措施" prop="provisionalMeasures">
        <el-input v-model="form.provisionalMeasures" type="textarea" placeholder="请输入临时措施" disabled :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
      </el-form-item>

<!--      <el-form-item-->
<!--        :prop="provisionalMeasuresFile"-->
<!--      >-->
<!--        <file-upload-list-->
<!--          ref="fileUploadList"-->
<!--          :fileList="form.provisionalMeasuresFile"-->
<!--        ></file-upload-list>-->
<!--      </el-form-item>-->

      <el-form-item label="永久方案" prop="permanentSolution">
        <el-input
          :disabled="receivedForm && receivedForm.permanentSolution !== ''"
          placeholder="请输入永久方案"
          v-model="form.permanentSolution"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 4 }"
          maxlength="500"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item prop="permanentSolutionFile">
        <file-upload-list
          ref="fileUploadList"
          :fileList="receivedForm.permanentSolutionFile"
        ></file-upload-list>
      </el-form-item>
      <el-form-item label="计划断点时间" prop="planBreakpointTime">
        <el-date-picker
          :disabled="
            receivedForm && receivedForm.planBreakpointTime != undefined
          "
          v-model="form.planBreakpointTime"
          type="date"
          placeholder="请选择计划断点时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="完成情况" prop="finishStatusInfo">
        <el-input
          v-model="form.finishStatusInfo"
          type="textarea"
          placeholder="请输入完成情况"
          :autosize="{ minRows: 4, maxRows: 4 }"
          maxlength="500"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item prop="finishStatusInfoFiles">
        <drag-upload
          ref="uploadFile"
          :accessoryList.sync="form.finishStatusInfoFiles"
          :httpRequest="imAction"
        />
      </el-form-item>
      <el-form-item label="改进措施图片" prop="provisionalMeasuresFile">
        <drag-upload
          ref="uploadFile"
          :accessoryList.sync="form.provisionalMeasuresFile"
          :httpRequest="imAction"
          accept="jpg, png, jpeg, svg"
          :tipStatus="false"
        />
        <p style="font-size:12px;line-height:1.5;color:#999;margin:2px 0">
          仅能上传图片，支持格式：JPG、PNG、JPEG、SVG格式，单张图片不超过500M
        </p>
      </el-form-item>
      <!--   实际断点时间    -->
      <el-form-item label="实际断点时间" prop="realityBreakpointTime">
        <el-date-picker
          v-model="form.realityBreakpointTime"
          type="date"
          placeholder="请选择实际断点时间"
        >
        </el-date-picker>
      </el-form-item>



      <el-form-item>
        <el-button class="lang-but" type="primary" @click="auditPassBtClick"
          >通过</el-button
        >
        <el-button class="lang-but" type="danger" @click="auditRejectBtClick"
          >驳回</el-button
        >
      </el-form-item>
    </el-form>

    <kd-audit-pass-dialog
      :visible.sync="auditPassDialogVisible"
      v-model="form.auditText"
      @confirm="onAuditPassConfirm"
    />

    <div>
      <el-dialog
        width="600px !important"
        title="审核驳回"
        :visible.sync="dialogVisible"
      >
        <el-form
          :model="form"
          :rules="rules"
          ref="rejectFormRef"
          label-width="85px"
        >
          <el-form-item label="驳回原因" prop="rejectReason">
            <el-input
              v-model="form.rejectReason"
              type="textarea"
              placeholder="请输入驳回原因"
              :autosize="{ minRows: 4, maxRows: 4 }"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="auditRejectSubmit()"
              >提交</el-button
            >
            <el-button plain @click="dialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </kd-container>
</template>
<script>
import { baseURL } from "../../util/url";
import { requestSubmitAuditKD } from "@/api/feedbackKD";
import KdAuditPassDialog from "./kdAuditPassDialog.vue";

/**
 * 16.2-责任单位填写完成情况
 */
export default {
  name: "kdAccountUnitWriteFinishStatusAudit",
  components: { KdAuditPassDialog },
  props: {
    disableForm: {
      type: Boolean,
      default: false,
    },
    taskId: String,
    questionId: String,
    taskDefKey: String,
    receivedForm: {
      type: Object,
      default: () => ({
        hasReasonAnalystMaterial: 0,
        reasonAnalystMaterial: "",
        reasonAnalyst: "",
        permanentSolution: "",
        permanentSolutionFile: [],
        planBreakpointTime: "",
        finishStatusInfo: "",
        finishStatusInfoFiles: undefined,
        requestCompletionProcess: "",
        file: undefined,
      }),
    },
  },
  data() {
    return {
      header: {
        satoken: sessionStorage.getItem("token"),
      },
      imAction: "/manage/staff/upload?fileType=auditResource",
      dialogVisible: false,
      auditPassDialogVisible: false,
      form: {
        userId: "",
        provisionalMeasures: "",
        reasonAnalystMaterial: "",
        reasonAnalyst: "",
        permanentSolution: "",
        permanentSolutionFile: [],
        provisionalMeasuresFile: [],
        finishStatusInfo: "",
        finishStatusInfoFiles: [],
        planBreakpointTime: "",
        realityBreakpointTime: "",
        handSuggestion: "",
        handSuggestionFiles: [],
        file: [],
        rejectReason: "",
        auditText: "",
      },
      rules: {
        reasonAnalyst: [
          {
            required: true,
            message: "根因分析不能为空",
            trigger: ["blur", "change"],
          },
        ],
        permanentSolution: [
          {
            required: true,
            message: "永久方案不能为空",
            trigger: ["blur", "change"],
          },
        ],
        planBreakpointTime: [
          {
            required: true,
            message: "计划断点时间不能为空",
            trigger: ["blur", "change"],
          },
        ],
        realityBreakpointTime: [
          {
            required: true,
            message: "实际断点时间不能为空",
            trigger: ["blur", "change"],
          },
        ],
        finishStatusInfo: [
          {
            required: true,
            message: "完成情况不能为空",
            trigger: ["blur", "change"],
          },
        ],
        provisionalMeasuresFile :[
          {
            required: true,
            message: "改进措施图片不能为空",
            trigger: ["blur", "change"],
          },
        ],
        rejectReason: [
          {
            required: true,
            message: "驳回原因不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    },
  },
  methods: {
    auditPassBtClick() {
      this.$refs["formRef"].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }
        this.auditPassDialogVisible = true;
      });
    },
    onAuditPassConfirm(auditText) {
      let formData = {
        nowTaskId: this.taskId,
        questionId: this.questionId,
        taskDefKey: this.taskDefKey,
        auditText: auditText,
        reasonAnalystData: this.form,
        variables: {
          approval: true,
        },
      };
      const today = new Date();
      today.setHours(23, 59, 59, 0);
      if (this.form.realityBreakpointTime && this.form.realityBreakpointTime > today) {
        this.$DonMessage.error("实际断点时间不能超过今天！");
        return;
      }
      requestSubmitAuditKD(formData).then((res) => {
        if (res.status == "0") {
          this.$DonMessage.success("审批通过!");
          this.backRouterPath();
        }else {
          this.$DonMessage.error(res.message);
        }
      });
    },
    auditRejectBtClick() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.rejectFormRef?.resetFields();
      });
    },
    auditRejectSubmit() {
      this.$refs["rejectFormRef"].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          auditText: this.form.rejectReason,
          variables: {
            approval: false,
          },
        };
        requestSubmitAuditKD(formData).then((res) => {
          if (res.status == "0") {
            this.$DonMessage.success("驳回成功!");
            this.backRouterPath();
            this.dialogVisible = false;
          } else {
            this.$DonMessage.error(res.message);
          }
        });
      });
    },
  },
  mounted() {
    if (this.receivedForm) {
      this.form.reasonAnalystMaterial =
        this.receivedForm.reasonAnalystMaterial ?? "";
      this.form.reasonAnalyst = this.receivedForm.reasonAnalyst ?? "";
      this.form.file = this.receivedForm.file ? this.receivedForm.file : [];
      this.form.permanentSolutionFile = this.receivedForm.permanentSolutionFile
        ? this.receivedForm.permanentSolutionFile
        : [];
      this.form.permanentSolution = this.receivedForm.permanentSolution
        ? this.receivedForm.permanentSolution
        : "";
      this.form.planBreakpointTime = this.receivedForm.planBreakpointTime
        ? this.receivedForm.planBreakpointTime
        : "";
      this.form.finishStatusInfo = this.receivedForm.finishStatusInfo
        ? this.receivedForm.finishStatusInfo
        : "";
      this.form.userId = this.receivedForm.userId ?? "";
      this.form.provisionalMeasures = this.receivedForm.provisionalMeasures ?? "";
      this.form.provisionalMeasuresFile = this.receivedForm.provisionalMeasuresFile ?? [];
      this.form.finishStatusInfoFiles = this.receivedForm.finishStatusInfoFiles ?? [];
    }
  },
};
</script>
